// src/pages/Dashboard.js
import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid, TextField, Box, Button } from "@mui/material";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import SaveIcon from "@mui/icons-material/Save";
import useProductData from "pages/Pawn/Report/IncomeExpenses/data/data";
import useColumns from "pages/Pawn/Report/IncomeExpenses/columns/mainColumns";
import dayjs from "dayjs";
import SearchBar from "components/TableExplanded/SearchBar";
import CustomTable from "components/TableExplanded/TableSpecial";
import api from "_api";
import { DatePicker } from "antd";
import { Search } from "@mui/icons-material";
import "../../../../assets/css/datepicker.css";

const IncomeExpenses = ({ className }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProduct, setProduct] = useState(null);
  const [fetchData, setFetchData] = useState([]);
  const [viewProduct, setViewProduct] = useState(null);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [totalBudget, setTotalBudget] = useState(null);
  const [searchStartDate, setSearchStartDate] = useState(null);
  const [searchEndDate, setSearchEndDate] = useState(null);

  const fetchProductData = async (date) => {
    try {
      const data = await api.product.getAllOrderAccount(date);
      // const { data: budget } = await api.product.getDashboard();
      // console.log("data API", data);
      if (data) {
        setFetchData(data);
      }
      // if (budget) {
      //   setTotalBudget(budget?.companyBudget?.budget);
      // }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {

    const currentDate =dayjs(new Date()).format(
      "YYYY-MM-DD"
    );
    // setSearchStartDate(dayjs(new Date()).format(
    //   "dd/mm/yyyy"
    // ))
    // setSearchEndDate(currentDate)
    fetchProductData({
      // from_date: currentDate,
      // to_date: currentDate,
    });
  }, []);
  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };
  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const data = useProductData(fetchData, totalBudget);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen
  );
  const visibleColumns = columns.filter((col) => col.showInFilter);

  const filteredData = useMemo(() => {
    if (!searchQuery) return data; // If no search query, return all data

    return data.filter((row) => {
      return visibleColumns.some((column) => {
        const cellValue = row[column.accessor]?.toString()?.toLowerCase();
        return cellValue && cellValue.includes(searchQuery.toLowerCase());
      });
    });
  }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    // Check if event.target and event.target.value are defined
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      setSearchTerm(event.target.value.toLowerCase());
      setSearchQuery(event.target.value);
    } else {
      console.error("Event target or value is undefined");
    }
  };

  const handleClear = () => {
    setSearchTerm("");
  };

  const handleExportExcel = async () => {
    await api.report
      .exportExcelIncomeAndExpenses()
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "download.xlsx"; // Default กรณีไม่มีชื่อไฟล์จาก API

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+?)"?$/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("Error exporting excel:", error);
      });
  };

  const handleSearchDate = async () => {
    console.log({ searchStartDate, searchEndDate });
    if (searchStartDate && searchEndDate) {
      // form_date & to_date
      const formattedStartDate = dayjs(searchStartDate, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      const formattedEndDate = dayjs(searchEndDate, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      console.log("Formatted Dates:", {
        formattedStartDate,
        formattedEndDate,
      });   
      fetchProductData({
        // from_date: formattedStartDate,
        // to_date: formattedEndDate,
      })
      const data = await api.product.getAllOrderAccount({
        from_date: formattedStartDate,
        to_date: formattedEndDate,
      });
      if (data) {
        setFetchData(data);
      }
    }
  };

  return (
    <div className={className}>
      <Grid container spacing={10} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            รายรับ-รายจ่าย
          </Typography>

          <GradientButton
            onClick={handleExportExcel}
            sx={{
              px: 3,
              display: "flex",
              alignItems: "center",
              height: "48px",
            }}
          >
            <Typography style={{ marginRight: "8px" }}>ส่งออก Excel</Typography>
            <SaveIcon fontSize="medium" />
          </GradientButton>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          marginTop: "16px",
        }}
      >
        <Grid
          container
          spacing={2}
          style={{ marginBottom: "8px", alignItems: "center" }}
        >
          <Grid item xs={12} sm={1} sx={{ textAlign: "right" }}>
            <Typography style={{ fontSize: "16px" }}>วันที่:</Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <DatePicker
              style={{ width: "100%" }}
              format="DD/MM/YYYY"
              value={
                searchStartDate ? dayjs(searchStartDate, "DD/MM/YYYY") : null
              }
              placeholder="วันที่เริ่ม"
              onChange={(date, dateString) => {
                setSearchStartDate(dateString);
              }}
              allowClear
              onClear={() => setSearchStartDate(null)}
              className="date-picker"
            />
          </Grid>
          <Grid item xs={12} sm={1} sx={{ textAlign: "center" }}>
            <Typography style={{ fontSize: "16px" }}>-</Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <DatePicker
              style={{ width: "100%" }}
              value={searchEndDate ? dayjs(searchEndDate, "DD/MM/YYYY") : null}
              format="DD/MM/YYYY"
              placeholder="วันที่สิ้นสุด"
              onChange={(date, dateString) => {
                // console.log("Selected date:", date, dateString);
                setSearchEndDate(dateString);
              }}
              allowClear
              onClear={() => setSearchEndDate(null)}
              className="date-picker"
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            width: "100%",
            gap: 2,
          }}
        >
          <GradientButtonOutline
            onClick={() => {
              setSearchStartDate(null);
              setSearchEndDate(null);
              fetchProductData();
            }}
          >
            <Typography>ล้าง</Typography>
          </GradientButtonOutline>
          <GradientButton endIcon={<Search />} onClick={handleSearchDate}>
            <Typography>ค้นหา</Typography>
          </GradientButton>
        </Box>
      </Box>
      <CustomTable columns={columns} data={filteredData} />
    </div>
  );
};

export default IncomeExpenses;
